exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * To be used with CSS Modules rendered by the webpack.config.\n * Any styles specific to the User Node module should live here.\n * Import as neede like so:\n * ...\n * import userNodeStyles from 'userNodeModuleStyles.css';\n * ...\n * render() {\n *   return(\n *     <div styleName=\"user-node-item\">\n * ...\n */\n\n.modules-userNode-___userNodeModuleStyles__user-node-item___1jBrX {\n\n}\n", ""]);

// exports
exports.locals = {
	"user-node-item": "modules-userNode-___userNodeModuleStyles__user-node-item___1jBrX"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/userNode/userNodeModuleStyles.css
// module id = 1368
// module chunks = 1